import HttpResponseType from '@/constants/api/HttpResponseType'

/**
 * @class
 * @public
 */
export default class AxiosRequestConfig {
  constructor({
    method,
    url,
    data = null,
    headers = null,
    responseType = HttpResponseType.json,
  } = {}) {
    /**
     * HTTP Method
     * @type {String}
     */
    this.method = method

    /**
     * Endpoint url
     * @type {String}
     */
    this.url = url

    /**
     * Payload to send to server
     * @type {*}
     */
    this.data = data

    /**
     * Dictionary of key pair values representing request headers
     * @type {Object}
     */
    this.headers = headers

    /**
     * A http response type. Please see `HttpResponseType`
     * @type {String}
     */
    this.responseType = responseType
  }
}
